import { LinearProgress } from "@mui/material";
import moment from "moment";
import { useEffect, useState } from "react";
import {
  AcceptedChip,
  PendingPersetujuanDosenChip,
  PendingRevisiMahasiswaChip,
  RejectedChip,
} from "../../../../components/common/Chips/Chips";
import {
  SimpleCardContainer,
  SimpleCardContent,
  SimpleCardTitle,
} from "../../../../components/common/SimpleCard/SimpleCard";
import { STATUS_REVISI_PARSE } from "../../../../utils/constants/EvaluasiSidang.constants";
import MahasiswaSidangService from "../../../../services/Integration/mahasiswa-sidang/MahasiswaSidangService";
import RevisiService from "../../../../services/Integration/revisi/RevisiService";
import CatatanDosenCol from "../../../dosen/sidang/evaluasi/riwayat-revisi/CatatanDosenCol";
import RevisiMahasiswaCol from "../../../dosen/sidang/evaluasi/riwayat-revisi/RevisiMahasiswaCol";
import FormRevisiMahasiswa from "./FormRevisiMahasiswa";
import { AlertColor } from "../../../../utils/constants/Color.constants";

export default function RevisiMahasiswa({ mKSpesialId }) {
  const [revisis, setRevisis] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [deadlineRevisi, setDeadlineRevisi] = useState(null);
  const [formIsOpen, setFormIsOpen] = useState(false);
  const [formRevisiDosen, setFormRevisiDosen] = useState(null);
  const [formNomorRevisi, setFormNomorRevisi] = useState(0);
  const [formDosenId, setFormDosenId] = useState("");

  useEffect(() => initRevisi(), []);

  const initRevisi = async () => {
    setIsLoading(true);
    await getRiwayatRevisiDosen();
    await getDeadlineRevisi();
    setIsLoading(false);
  };

  const getRiwayatRevisiDosen = async () => {
    await MahasiswaSidangService.getRiwayatRevisiByMKSpesialID(mKSpesialId)
      .then((response) => {
        if (response.status === 200) {
          setRevisis(response.data);
        } else {
          console.log(response);
        }
      })
      .catch((error) => console.log(error));
  };

  const getDeadlineRevisi = async () => {
    await RevisiService.getDeadlineRevisi(mKSpesialId).then((response) => {
      if (response.status === 200) {
        if (response.data.length > 0) setDeadlineRevisi(response.data[0]);
      }
    });
  };

  const getDeadlineRevisiAsMoment = () =>
    moment(
      `${deadlineRevisi.tanggal_deadline_revisi} ${deadlineRevisi.waktu_deadline_revisi}`,
      "YYYY-MM-DD HH:mm:ss"
    );

  return (
    <div className="mt-4">
      {isLoading ? (
        <LinearProgress />
      ) : (
        <div className="flex flex-col gap-4">
          {revisis.length === 0 ? (
            <div className="w-full text-center font-bold">
              <div className="text-lg">Perhatian!</div>
              <div>
                Dosen belum memberikan anda catatan revisi. Silakan menunggu
                atau menghubungi dosen pembimbing atau penguji untuk memberikan
                catatan revisi terhadap laporan tugas akhir anda.
              </div>
            </div>
          ) : (
            <div>
              <span className="font-bold">Deadline revisi: </span>
              <span className="font-bold text-red-500">
                {deadlineRevisi !== null
                  ? `${getDeadlineRevisiAsMoment().format(
                      "DD/MM/YYYY HH:mm"
                    )} WIB`
                  : "-"}
              </span>
              <div>
                <small className="text-red-500">
                  * Anda tidak dapat melakukan submisi <b>JIKA</b> sudah
                  melewati deadline.
                </small>
              </div>
            </div>
          )}
          {revisis.map((revisiDetail, index) => (
            <SimpleCardContainer key={index + 1}>
              <SimpleCardTitle>
                Riwayat revisi dari {revisiDetail.nama_lengkap}
              </SimpleCardTitle>
              <SimpleCardContent>
                <table className="w-full table-fixed border border-slate-300 border-collapse border-spacing-4">
                  <thead>
                    <tr>
                      <th className="w-16 border-r border-white bg-slate-300">
                        Nomor Revisi
                      </th>
                      <th className="border-x border-white w-64 bg-slate-300">
                        Status Revisi
                      </th>
                      <th className="border-x border-white bg-slate-300">
                        Catatan Dosen
                      </th>
                      <th className="border-x border-white bg-slate-300">
                        Berkas Revisi
                      </th>
                      <th className="w-36 border-l border-white bg-slate-300">
                        Aksi
                      </th>
                    </tr>
                  </thead>
                  <tbody className="text-sm">
                    {revisiDetail.revisi.map((revisi, index) => {
                      return (
                        <tr key={index + 1} className="border border-slate-300">
                          <td className="text-center border border-slate-300">
                            {index + 1}
                          </td>
                          <td className="text-center border border-slate-300">
                            {revisi.status === STATUS_REVISI_PARSE.Ditolak && (
                              <RejectedChip />
                            )}
                            {revisi.status ===
                              STATUS_REVISI_PARSE.Disetujui && <AcceptedChip />}
                            {revisi.status ===
                              STATUS_REVISI_PARSE[
                                "Menunggu revisi mahasiswa"
                              ] && <PendingRevisiMahasiswaChip />}
                            {revisi.status ===
                              STATUS_REVISI_PARSE[
                                "Menunggu evaluasi dosen"
                              ] && (
                              <PendingPersetujuanDosenChip
                                hexColor={AlertColor.pending}
                              />
                            )}
                          </td>
                          <td className="border border-slate-300">
                            <CatatanDosenCol
                              catatanDosen={{
                                catatan_revisi: revisi.catatan_revisi,
                                nama_berkas_revisi: revisi.nama_berkas_revisi,
                              }}
                            />
                          </td>
                          <td className="border border-slate-300">
                            <RevisiMahasiswaCol
                              revisiMahasiswa={revisi.revisi_mahasiswa}
                            />
                          </td>
                          <td className="border border-slate-300 text-center">
                            {deadlineRevisi !== null &&
                            getDeadlineRevisiAsMoment().isBefore(moment()) ? (
                              "-"
                            ) : revisi.status ===
                              STATUS_REVISI_PARSE[
                                "Menunggu revisi mahasiswa"
                              ] ? (
                              <button
                                className="py-2 px-4 font-bold text-blue-500 rounded-md border border-blue-500 hover:text-white hover:bg-blue-500"
                                onClick={() => {
                                  setFormNomorRevisi(index + 1);
                                  setFormDosenId(revisiDetail.dosen);
                                  setFormRevisiDosen({
                                    id: revisi.id,
                                    catatanRevisi: revisi.catatan_revisi ?? "",
                                    namaBerkasRevisi:
                                      revisi.nama_berkas_revisi ?? "",
                                  });
                                  setFormIsOpen(true);
                                }}
                              >
                                Unggah Revisi
                              </button>
                            ) : (
                              "-"
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </SimpleCardContent>
            </SimpleCardContainer>
          ))}
          <FormRevisiMahasiswa
            open={formIsOpen}
            setOpen={setFormIsOpen}
            refreshRevisiDosen={getRiwayatRevisiDosen}
            mKSpesialId={mKSpesialId}
            dosenId={formDosenId}
            revisiDosen={formRevisiDosen}
            nomorRevisi={formNomorRevisi}
          />
        </div>
      )}
    </div>
  );
}
